import { APIResponse, APIUtility } from "./ApiUtility";
import { AccountDTO } from "./Interface/Account/AccountInterface";
class LauncherAPI {
  private apiUtility: APIUtility;
  private baseURL: string;

  constructor(baseURL: string = "https://ss-rp.com/api/v1/") {
    this.baseURL = baseURL;
    this.apiUtility = new APIUtility(baseURL);
    // this.apiUtility.setDefaultHeaders({});
  }

  async authenticate(username: string, password: string): Promise<void> {
    const response = await this.apiUtility.post("login", {
      username,
      password,
    });

    console.log("Authenticated successfully");
  }

  //   async getSessions(): Promise<any> {
  // //     const authToken = document.cookie
  // //         .split('; ')
  // //         .find(row => row.startsWith('AuthorizationCookie='))
  // //         ?.split('=')[1];
  // // console.log(authToken)
  // //     if (!authToken) {
  // //         // Handle case where authentication token is not found
  // //         console.error("Authentication token not found in cookies.");
  // //         return;
  // //     }

  // //     const customHeaders = {
  // //         Authorization: `Bearer ${authToken}`,
  // //     };

  //     const response = await this.apiUtility.get("api/v1/launcher/session/list");

  //     // Handle the response as needed
  //     return response;
  // }
  async getAllActiveSessions(): Promise<any> {
    return this.apiUtility.get("launcher/session/list");
  }

  async getSessions(id: number): Promise<any> {
    return this.apiUtility.get(`launcher/session/list/${id}`);
  }

  async forceUser(id: number): Promise<APIResponse<AccountDTO>> {
    return this.apiUtility.post(`launcher/force`, { id });
  }

  async getScreenshot(sessId: string): Promise<any> {
    return this.apiUtility.post(`launcher/screenshot/request/${sessId}`);
  }

  async checkFileUses(name: string, hash: string): Promise<any> {
    const response = await this.apiUtility.post("launcher/file/uses", {
      name,
      hash,
    });

    return response.data;
  }

  async getCurrentGameDirectory(sessId: string): Promise<any> {
    const response = await this.apiUtility.post("launcher/directory/display", {
      sessId,
    });

    return response.data;
    // Process the json data as needed
  }

  async takeScreenshot(sessId: string): Promise<any> {
    const response = await this.apiUtility.post(
      "launcher/screenshot/display",
      { sessId }
    );
    return response.data;
  }

  async getActiveProcesses(sessId: string): Promise<any> {
    const response = await this.apiUtility.post("launcher/processes/display", {
      sessId,
    });

    return response.data;
  }

  async getSessionData(sessId: string): Promise<any> {
    const response = await this.apiUtility.get(`launcher/session/${sessId}`);

    return response.data;
  }

  async getLauncherLogs(sessId: string): Promise<any> {
    const response = await this.apiUtility.post("launcher/logs", { sessId });

    return response.data;
  }

  async compileFileDownload(
    name: string,
    hash: string,
    sessId: string
  ): Promise<void> {
    try {
      // Retrieve content from client
      const response = await this.apiUtility.get(
        `launcher/directory/files/content/${name}/${hash}`
      );

      if (response.success) {
        const response2 = await this.apiUtility.post(
          "launcher/file/content/view",
          {}
        );

        if (response2.success) {
          const json = response2.data;
          console.log(json);
        } else {
          console.error("Failed to fetch file content");
        }
      } else {
        console.error("Failed to fetch directory file content");
      }
    } catch (error) {
      console.error("Error fetching file content:", error);
      // Handle the error as needed
    }
  }

  // Cheat Signature Management APIs

  // GET /signatures/list
  async getCheatSignatures(): Promise<any> {
    return this.apiUtility.get("launcher/signatures/list");
  }

  // POST /signatures/add — manual JSON entry
  async addCheatSignature(signature: {
    file_name: string;
    file_hash: string;
    signature_type: string;
    block_type: string;
    file_size?: number;
  }): Promise<any> {
    return this.apiUtility.post("launcher/signatures/add", signature);
  }

  // POST /signatures/upload/file — multipart, server calculates name/hash/size
  async uploadSignatureFile(
    file: File,
    signature_type: string,
    block_type: string
  ): Promise<any> {
    const form = new FormData();
    form.append("file", file);
    form.append("signature_type", signature_type);
    form.append("block_type", block_type);
    return this.apiUtility.post("launcher/signatures/upload/file", form);
  }

  // POST /signatures/upload — bulk JSON insert
  async uploadCheatSignatures(signatures: {
    file_name: string;
    file_hash: string;
    signature_type: string;
    block_type: string;
    file_size?: number;
  }[]): Promise<any> {
    return this.apiUtility.post("launcher/signatures/upload", { signatures });
  }

  // PUT /signatures/:id — partial update
  async updateCheatSignature(
    id: number,
    signature: {
      file_name?: string;
      file_hash?: string;
      signature_type?: string;
      block_type?: string;
      file_size?: number;
    }
  ): Promise<any> {
    return this.apiUtility.put(`launcher/signatures/${id}`, signature);
  }

  // DELETE /signatures/:id
  async deleteCheatSignature(id: number): Promise<any> {
    return this.apiUtility.delete(`launcher/signatures/${id}`);
  }

  // Model Management APIs

  // GET /models/list
  async listModels(): Promise<any> {
    return this.apiUtility.get("launcher/models/list");
  }

  // POST /models/upload — multipart/form-data, field name: model
  async uploadModel(file: File): Promise<any> {
    const form = new FormData();
    form.append("model", file);
    return this.apiUtility.post("launcher/models/upload", form);
  }

  // DELETE /models/:name
  async deleteModel(name: string): Promise<any> {
    return this.apiUtility.delete(`launcher/models/${encodeURIComponent(name)}`);
  }

  // GET /models/:name — returns raw image bytes, resolved as a blob URL
  async getModelImage(name: string): Promise<string | null> {
    const response = await fetch(
      `${this.baseURL}launcher/models/${encodeURIComponent(name)}`,
      { credentials: "include" }
    );
    if (!response.ok) return null;
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  }

  // News & Feed APIs

  // GET /news — protected, ordered by created_at DESC
  async getNews(): Promise<any> {
    return this.apiUtility.get("launcher/news");
  }

  // POST /news — admin >= 8, body: { category, description }
  async postNews(category: string, description: string): Promise<any> {
    return this.apiUtility.post("launcher/news", { category, description });
  }

  // PUT /news/:id — { category?, description? }
  async updateNews(id: number, updates: { category?: string; description?: string }): Promise<any> {
    return this.apiUtility.put(`launcher/news/${id}`, updates);
  }

  // DELETE /news/:id
  async deleteNews(id: number): Promise<any> {
    return this.apiUtility.delete(`launcher/news/${id}`);
  }

  // GET /changelogs — protected, ordered by discord_timestamp DESC
  async getChangelogs(): Promise<any> {
    return this.apiUtility.get("launcher/changelogs");
  }

  // GET /feed — not protected, latest 5 from both combined
  async getFeed(): Promise<any> {
    return this.apiUtility.get("launcher/feed");
  }

  // GET /discord-members — not protected, reads server_vars.discord_members
  async getDiscordMembers(): Promise<any> {
    return this.apiUtility.get("launcher/discord-members");
  }
}

export default LauncherAPI;
